const emptyButton = {
  title: '',
  color: '',
  itemId: '',
  pageId: '',
  offerId: '',
};

export const generateGrid = (totalColumns: number, totalRows: number) => {
  return new Array(totalColumns * totalRows).fill(0).map((_, i) => ({
    id: i,
    x: i % totalColumns,
    y: Math.floor(i / totalColumns),
    ...emptyButton,
  }));
};
